<template>
    <div class="container">
        <Carousel v-bind="settings" :breakpoints="breakpoints">
        <Slide v-for="post in posts" :key="post.id">
            <div class="card pb-4">
            <router-link :to="{
                name: 'ModelPageChild',
                params: {
                    locale: locale,
                    name: post.slug,
                    complement: 'photo'
                }
                }">
                <img :src="`${post.cover}`" :alt="post.title" width="516" height="382" />
            </router-link>        
            <div class="card-body d-flex flex-column align-items-start">
                <router-link :to="{
                name: 'ModelPageChild',
                params: {
                    locale: locale,
                    name: post.slug,
                    complement: 'photo'
                }
                }" class="button--more">
                <h5 class="card-title">{{ post.title }}</h5>
                </router-link>
            </div>
            </div>
        </Slide>
        </Carousel>

        <div class="row d-flex align-items-center justify-content-center">
            <button type="button" class="more-blog my-lg-5 mt-2 mb-4 p-3 col-lg-5 col-11" @click="redirect('ModelsPage')">{{ translate.seeAllModels }}
            <font-awesome-icon :icon="['fas', 'arrow-right']" size="lg"/></button>
        </div>
    </div>    
  </template>
  
  <script lang="ts">
  import { mapState } from 'pinia'
  import { defineComponent } from 'vue'
  import { Carousel, Slide } from 'vue3-carousel'
  import modelsTradutor from 'tradutors/models'
  import router from "router";
    
  import 'vue3-carousel/dist/carousel.css'
  import { localeStore } from 'stores/locale'
  
  export default defineComponent({
    name: 'CarouselModels',
    components: {
      Carousel,
      Slide
    },
    props: ['posts'],
    computed: {
      ...mapState(localeStore, ['locale']),
      translate: function () {
        if (this.locale === 'pt-br') {
          return modelsTradutor.portugues
        } else {
          return modelsTradutor.ingles
        }
      }
    },
    data: () => ({
      // carousel settings
      settings: {
        autoplay: 100,
        wrapAround: true,
        itemsToShow: 1.05,
        itemsToScroll: 1,
        transition: 6000
      },
      // breakpoints are mobile first
      // any settings not specified will fallback to the carousel settings
      breakpoints: {
        // 700px and up
        600: {
          itemsToShow: 2.05,
        },
        // 1024 and up
        800: {
          itemsToShow: 3.05,
        }
      }
    }),
    methods: {
        redirect(name) {
            router.push({ name, params: { locale: this.localeTemp } });
        }
    }       
  })
  </script>
  <style scoped>
  .card-title {
    color: #B20000;
    font-family: 'Roboto-Medium';
    font-size: 18px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 22px;
    margin-top: 18px;
  }
  
  .button--more svg {
    color: #b20000;
  }
  
  .button--more {
    height: 19px;
    color: #5b5858;
    font-family: "Exo-2";
    font-size: 16px;
    letter-spacing: 0;
    line-height: 19px;
  }
  
  .small svg {
    margin-right: 5px;
  }
  
  .card img {
    width: 100%;
    object-fit: cover;
    height: auto;
  }
  
  .card {
    background-color: #fff;
    padding-right: 15px;
  }
  
  .card-body {
    padding: 0px;
  }
  :deep(.carousel__pagination-button::after) {
      display: block;
      content: '';
      width: 8px;
      height: 8px;
      border-radius: 50%;
      opacity: 0.2;
      background-color: #000000;
      margin-right: 15px;
  }
  
  :deep(.carousel__pagination-button--active) {
    background-color: #000000;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    margin-right: 15px;
    top: 2px;
  }
  
  .more-blog {
    font-size: 1rem !important;
    font-weight: 900;
    background-color: black !important;
    border: 1px solid black !important;
    border-radius: 30px !important;
    color: white;
  }

  .more-blog svg {
    color: #b20;
    margin-left: 8px;
  }    
  /* regras mobile 769vp */
  @media screen and (max-width: 769px) {
    .card {
      padding-right: 12px;
    }
    .more-blog {
     font-size: 13px !important;
    }
  }
  
  </style>
  